<template>
  <div>
    <apexchart 
      type="bar" 
      height="450" 
      :options="chartOptions" 
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 's-stacked-column-chart',
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    xAxisData: {
      type: Array,
      required: true,
    },
    yAxisData: {
      type: Array,
      required: true,
    },
    showAverage: {
      type: Boolean,
      default: false,
    },
    xAxisAverageOntimeefficiency: {
      type: Object,
      default: () => {},
    },
    colors: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    series() {
      return this.yAxisData;
    },
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          toolbar: {
            show: true
          },
          zoom: {
            enabled: true
          }
        },
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0
            }
          }
        }],
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10,
            borderRadiusApplication: 'end', // 'around', 'end'
            borderRadiusWhenStacked: 'last', // 'all', 'last'
            dataLabels: {
              total: {
                enabled: true,
                formatter: (val, opts) => {
                  if (this.showAverage) {
                    const average = this.xAxisAverageOntimeefficiency[opts.globals.labels[opts.dataPointIndex]];
                    return `${average}%`;
                  }
                  return val;
                },
                style: {
                  fontSize: '13px',
                  fontWeight: 900
                }
              }
            }
          },
        },
        colors: this.colors,
        xaxis: {
          position: 'top',
          categories: this.xAxisData,
          labels: {
            offsetY: -10,
            style: {
              fontSize: '12px',
              fontWeight: 400
            }
          }
        },
        legend: {
          position: 'right',
          offsetY: 40
        },
        fill: {
          opacity: 1
        },
        title: {
          text: this.title,
          floating: true,
          offsetY: 430,
          align: 'center',
          style: {
            color: '#444'
          }
        }
      };
    }
  }
}
</script>